import { Button, Flex } from "@p0security/ui";
import { useScreen } from "hooks/useScreen";

export const ShowMore: React.FC<{
  onClick?: React.MouseEventHandler<HTMLElement>;
  text: string;
  visible: boolean;
}> = ({ onClick, text, visible }) => {
  const { xxl } = useScreen();
  return (
    <Flex className="w-full" justify="flex-end">
      <Button
        /* eslint-disable-line react/forbid-component-props */ style={{
          visibility: visible ? "visible" : "hidden",
        }}
        onClick={onClick}
      >
        {xxl ? text : "View"}
      </Button>
    </Flex>
  );
};
